<template>
  <canvas id="graph-commission-per-day" height="120"></canvas>
</template>

<script>
  import { chain, max, values } from 'lodash'
  import { mapActions } from 'vuex'
  import Chart from 'chart.js'

  export default {
    data () {
      return {
        chart: null,
        jobs: []
      }
    },

    created () {
      this.getCommissionPerDayGraph()
        .then((response) => {
          this.jobs = response.data
        })
        .then(this.initializeGraph)
    },

    methods: {
      ...mapActions('dashboard', ['getCommissionPerDayGraph']),

      initializeGraph () {
        if (this.chart) {
          this.chart.destroy()
        }

        this.chart = new Chart(this.$el.getContext('2d'), {
          type: 'line',
          data: {
            labels: chain(this.jobs).keys().reverse().value(),
            datasets: [
              {
                label: 'Total',
                backgroundColor: 'rgba(54,175,227,0.5)',
                borderColor: 'rgba(54,175,227,1)',
                pointBackgroundColor: 'rgba(54,175,227,1)',
                pointBorderColor: '#fff',
                data: chain(this.jobs).values().reverse().value()
              }
            ]
          },
          options: {
            responsive: true,
            legend: {
              onClick: (e) => e.stopPropagation()
            },
            scales: {
              xAxes: [{
                scaleLabel: {
                  display: true,
                  labelString: '# Days ago'
                },
                ticks: {
                  callback (value, index, values) {
                    return parseInt(value) === -1
                      ? value
                      : (parseInt(value) % 5 === 0 ? value : '')
                  }
                }
              }],
              yAxes: [{
                scaleLabel: {
                  display: false,
                  labelString: '# of Jobs'
                },
                ticks: {
                  max: Math.round(Math.ceil(max(values(this.jobs))) * 1.1),
                  beginAtZero: true
                }
              }]
            }
          }
        })
      }
    },

    beforeDestroy () {
      if (this.chart) {
        this.chart.destroy()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CommissionPerDayGraph.vue?45317604